import { Intercom, shutdown } from '@intercom/messenger-js-sdk';
import { env } from 'env';
import { useEffect } from 'react';
import { GraphQLFetchPolicies } from 'shared/enums';
import { useIntegrationsProvider } from 'shared/providers/IntegrationsProvider';
import { useGenerateIntercomJwtMutation } from 'shared/types/graphql';
import useClinicUser from './useClinicUser';
import { useModularity } from './useModularity';

const useIntercom = (): void => {
  const { isRecapClinic } = useModularity();
  const { clinicUser, currentClinic } = useClinicUser();
  const { primaryIntegrationName } = useIntegrationsProvider();
  const [generateIntercomJwt, { data: intercomJwtData }] = useGenerateIntercomJwtMutation({
    fetchPolicy: GraphQLFetchPolicies.NoCache,
  });

  useEffect(() => {
    if (isRecapClinic && clinicUser?.id) {
      // Ensure this runs after the current call stack to give time for generateIntercomJwt to be defined
      setTimeout(() => {
        generateIntercomJwt();
      });
    }
  }, [clinicUser, isRecapClinic, generateIntercomJwt]);

  useEffect(() => {
    if (intercomJwtData?.generateIntercomJwt) {
      shutdown();
      Intercom({
        app_id: env.REACT_APP_INTERCOM_APP_ID,
        intercom_user_jwt: intercomJwtData?.generateIntercomJwt,
        hide_default_launcher: true,
        name: clinicUser?.nameDisplay || `${clinicUser?.firstName} ${clinicUser?.lastName}`,
        phone: clinicUser?.phone?.[0],
        pims_system: primaryIntegrationName,
        clinic_name: currentClinic?.name,
      });
    }
    return (): void => {
      shutdown();
    };
  }, [
    clinicUser?.firstName,
    clinicUser?.lastName,
    clinicUser?.nameDisplay,
    clinicUser?.phone,
    currentClinic?.name,
    intercomJwtData?.generateIntercomJwt,
    primaryIntegrationName,
  ]);
};

export default useIntercom;
